import { useMutation } from 'react-query';
import { updateDemandSend } from 'src/services/api/demands';

function useUpdateDemandSend() {
  return useMutation(({ demand, data }) => updateDemandSend(demand, data));
}

export default useUpdateDemandSend;
